
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useVoting } from "@/hooks/useVoting";

interface VoteButtonProps {
  votes: number;
  tipId: number;
  emoji: string;
  onVote: () => void;
  onPrizeWon: (prize: { name: string; description: string }) => void;
}

export function VoteButton({ votes, tipId, emoji, onVote, onPrizeWon }: VoteButtonProps) {
  const navigate = useNavigate();
  const { isVoted, setIsVoted, isLoading, handleVote } = useVoting({
    tipId,
    currentVotes: votes,
    onVote,
    onPrizeWon
  });

  const handleVoteClick = async () => {
    console.log('Vote button clicked, current states:', { isVoted, isLoading });

    if (!isLoading && !isVoted) {
      const audio = new Audio("/sfx/vote.aac");
      audio.play().catch(error => console.error("Audio playback error:", error));

      await handleVote();
      navigate('/game/spin', { state: { tipId } });  // Remove setIsVoted from state
    }
  };

  return (
    <>
      <div className="vote_button" onClick={handleVoteClick}>
        <div className="vote_button-insideG">
          <div className="vote_button-insideBorder"></div>
          <div className="vote_button-inside">
            <img src="/imgs/light.png" alt="img" className="vote_button-img" />
            <span className="vote_button-icon">{emoji}</span>
            <span className="vote_button-text absolute font-DiloWorld voteBG">VOTE</span>
            <span className="vote_button-text absolute font-DiloWorld voteFG">VOTE</span>
          </div>
        </div>
      </div>
    </>
  );
}
